/*
 * Wrap App in Router so the root component has access to the router history object
 * Required for Okta auth
 */

import React, { Component } from 'react';
import { BrowserRouter as Router } from "react-router-dom";

import App from './App';

class WrappedApp extends Component {
  render () {
    return (
      <Router>
        <App />
      </Router>
    )
  }
}

export default WrappedApp